/* External */
import { all, call, put, takeLatest } from "redux-saga/effects";

/* Actions */
import * as actions from "./actions";

/* Services */
import { getConfigurationFromAEM as getConfigurationFromAEMService } from "./services";

function* getConfigurationAEM() {
  try {
    yield put(actions.getConfigurationFromAEMRequest());
    const { data: configurationAEM } = yield call(getConfigurationFromAEMService);
    configurationAEM.lastRequestDate = new Date();
    yield put(actions.getConfigurationFromAEMSuccess(configurationAEM));
  } catch (error) {
    console.error(`global-sagas-getConfigurationAEM: ${error}`);
    yield put(actions.getConfigurationFromAEMFailure(error));
  }
}

export default function* root() {
  yield all([yield takeLatest(actions.ACTIONS_GET_CONFIGURATION_FROM_AEM.GET, getConfigurationAEM)]);
}
